var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 1.72303C5.57422 1.57068 6.49219 1.64881 7.34375 1.93006L9.28906 4.9574L6.34375 7.90272C6.28516 7.96131 6.25 8.04334 6.25391 8.12928C6.25781 8.21522 6.29297 8.29334 6.35547 8.35193L10.7305 12.4144C10.8438 12.5199 11.0195 12.5277 11.1406 12.4262C11.2617 12.3246 11.2891 12.1527 11.207 12.0199L8.84766 8.18787L12.3906 5.23475C12.4922 5.15272 12.5273 5.01209 12.4844 4.891L11.5938 2.41443C12.707 1.76209 14.0312 1.50818 15.332 1.72693C18.0273 2.17225 20 4.50037 20 7.23084V7.4574C20 9.0785 19.3281 10.6293 18.1406 11.7347L11.082 18.3246C10.7891 18.598 10.4023 18.7504 10 18.7504C9.59766 18.7504 9.21094 18.598 8.91797 18.3246L1.85938 11.7347C0.671875 10.6293 0 9.0785 0 7.4574V7.23084C0 4.50037 1.97266 2.17225 4.66406 1.72303Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateLike);
export default __webpack_public_path__ + "static/media/deactivateLike.444ddef5902da3f95f87c90e64c421fc.svg";
export { ForwardRef as ReactComponent };